import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import CompareTrialPlanTableHeaderCell from './CompareTrialPlanTableHeaderCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const THead = styled.thead.withConfig({
  displayName: "CompareTrialPlanTableStaticHeader__THead",
  componentId: "sc-1ywpqn0-0"
})(["height:150px;vertical-align:bottom;& tr th:first-of-type{font-size:1.5rem;font-weight:600;text-align:left;line-height:100%;border:none !important;}"]);
const CompareTrialPlanTableStaticHeader = ({
  levelsAndApiNames,
  upgradePointProductLevel,
  upgradePointApiName,
  purchaseMotions
}) => {
  return /*#__PURE__*/_jsx(THead, {
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("th", {
        className: "p-bottom-3 p-left-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.productCatalog.tableHeader.features"
        })
      }), levelsAndApiNames.map((item, i) => {
        return /*#__PURE__*/_jsx(CompareTrialPlanTableHeaderCell, {
          columns: levelsAndApiNames.length,
          productLevel: item.level,
          productLine: item.productLine,
          upgradePointProductLevel: upgradePointProductLevel,
          currentTrialColumn: i === 0,
          upgradePointApiName: upgradePointApiName,
          purchaseMotions: purchaseMotions
        }, item.level);
      })]
    })
  });
};
export default CompareTrialPlanTableStaticHeader;